import { Box } from '@material-ui/core';
import { Currency, getMoneySymbolByCurrency } from '@nemuru-eng/js-api-client';

import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface EditVehicleAmountControlProps {
  currency: Currency;
  disabled?: boolean;
}

export const EditVehicleAmountControl = ({ currency, disabled = false }: EditVehicleAmountControlProps) => {
  const { palette, customBorderRadius } = useCustomTheme();

  return (
    <Box
      display="flex"
      width={'260px'}
      style={{
        paddingInline: 12,
        paddingBlock: 8,
        borderRadius: customBorderRadius.paper,
        backgroundColor: palette.grey[50],
      }}
    >
      <NumberFormField
        name="item.price"
        valueUnit={getMoneySymbolByCurrency(currency)}
        label="VEHICLE_AMOUNT"
        fieldVariant={FieldVariant.form}
        disabled={disabled}
      />
    </Box>
  );
};
